<template>
  <div>
    <el-table
      :data="dataQualityForRegionList"
      :header-cell-style="{ background: '#f2f2f2', color: 'black' }"
      :span-method="arraySpanMethod"
      border
      max-height="600"
      row-key="id"
      stripe
    >
      <el-table-column
        align="center"
        label="大区(regiões)"
        min-width="150"
        prop="region"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{ scope.row.region || '--' }}</span>
        </template>
      </el-table-column>

      <el-table-column
        align="center"
        label="州 Estado"
        min-width="100"
        prop="state"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{ scope.row.state || '--' }}</span>
        </template>
      </el-table-column>

      <el-table-column
        align="center"
        label="下单量(Qtd. dos pedidos)"
        min-width="150"
        prop="totalOrderCount"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{ scope.row.totalOrderCount.toLocaleString() || 0 }}</span>
        </template>
      </el-table-column>

      <el-table-column
        align="center"
        label="出仓量(Qtd. de saída da encomenda)"
        min-width="180"
        prop="outboundCount"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{ scope.row.outboundCount.toLocaleString() || 0 }}</span>
        </template>
      </el-table-column>

      <el-table-column
        align="center"
        label="揽收量(Coletas realizadas)"
        min-width="150"
        prop="collectCount"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{ scope.row.collectCount.toLocaleString() || 0 }}</span>
        </template>
      </el-table-column>

      <el-table-column
        align="center"
        label="揽收率(Porcentagem de coleta)"
        min-width="160"
        prop="collectRate"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{ ((parseFloat(scope.row.collectRate) || 0) * 100).toFixed(2) + '%' }}</span>
        </template>
      </el-table-column>

      <el-table-column
        align="center"
        label="准时揽收量(Coletas pontuais)"
        min-width="150"
        prop="collectOnTimeCount"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{ scope.row.collectOnTimeCount.toLocaleString() || 0 }}</span>
        </template>
      </el-table-column>

      <el-table-column
        align="center"
        label="准时揽收率(Porcentagem de coleta pontual)"
        min-width="200"
        prop="collectOnTimeRate"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{ ((parseFloat(scope.row.collectOnTimeRate) || 0) * 100).toFixed(2) + '%' }}</span>
        </template>
      </el-table-column>

      <el-table-column
        align="center"
        label="妥投量(Entregas concluídas)"
        min-width="150"
        prop="deliveryCount"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{ scope.row.deliveryCount.toLocaleString() || 0 }}</span>
        </template>
      </el-table-column>

      <el-table-column
        align="center"
        label="妥投率(Porcentagem de entrega)"
        min-width="180"
        prop="deliveryRate"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{ ((parseFloat(scope.row.deliveryRate) || 0) * 100).toFixed(2) + '%' }}</span>
        </template>
      </el-table-column>

      <el-table-column
        align="center"
        label="理应送达量(Qtd. de pacote deve ser entregue)"
        min-width="200"
        prop="shouldDeliveryCount"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{ scope.row.shouldDeliveryCount.toLocaleString() || 0 }}</span>
        </template>
      </el-table-column>

      <el-table-column
        align="center"
        label="准时妥投量(Entregas pontuais)"
        min-width="170"
        prop="deliveryOnTimeCount"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{ scope.row.deliveryOnTimeCount.toLocaleString() || 0 }}</span>
        </template>
      </el-table-column>

      <el-table-column
        align="center"
        label="准时妥投率(Porcentagem de entrega pontual)"
        min-width="170"
        prop="deliveryOnTimeRate"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{
            ((parseFloat(scope.row.deliveryOnTimeRate) || 0) * 100).toFixed(2) + '%'
          }}</span>
        </template>
      </el-table-column>

      <el-table-column
        align="center" label="p90" min-width="100"
        prop="P90" show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{ scope.row.p90 || 0 }}</span>
        </template>
      </el-table-column>

      <el-table-column
        align="center"
        label="确认丢失量(Perdas confirmadas)"
        min-width="150"
        prop="lostCount"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{ scope.row.lostCount.toLocaleString() || 0 }}</span>
        </template>
      </el-table-column>

      <el-table-column
        align="center"
        label="丢失率(Porcentagem da perda)"
        min-width="180"
        prop="lostRate"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{ ((parseFloat(scope.row.lostRate) || 0) * 100).toFixed(2) + '%' }}</span>
        </template>
      </el-table-column>

      <el-table-column
        align="center"
        label="破损量(Encomendas danificadas)"
        min-width="150"
        prop="damagedCount"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{ scope.row.damagedCount.toLocaleString() || 0 }}</span>
        </template>
      </el-table-column>

      <el-table-column
        align="center"
        label="破损率(Porcentagem de danos)"
        min-width="180"
        prop="damagedRate"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{ ((parseFloat(scope.row.damagedRate) || 0) * 100).toFixed(2) + '%' }}</span>
        </template>
      </el-table-column>

      <el-table-column
        align="center"
        label="虚假签收量(Fake deliveries)"
        min-width="180"
        prop="fakeSignCount"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{ scope.row.fakeSignCount.toLocaleString() || 0 }}</span>
        </template>
      </el-table-column>

      <el-table-column
        align="center"
        label="虚假签收率(Porcentagem de fake deliveries)"
        min-width="200"
        prop="fakeSignRate"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{ ((parseFloat(scope.row.fakeSignRate) || 0) * 100).toFixed(2) + '%' }}</span>
        </template>
      </el-table-column>

      <el-table-column
        align="center"
        label="轨迹断更新20天量(Rastreamento sem atualização há 20 dias)"
        min-width="200"
        prop="trackBreakCount"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{ scope.row.trackBreakCount.toLocaleString() || 0 }}</span>
        </template>
      </el-table-column>

      <el-table-column
        align="center"
        label="超时效未闭环量(Casos fora do prazo não concluídos)"
        min-width="200"
        prop="timeoutUnclosedCount"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{ scope.row.timeoutUnclosedCount.toLocaleString() || 0 }}</span>
        </template>
      </el-table-column>

      <el-table-column
        align="center"
        label="轨迹完整率(Rastreamentos completos)"
        min-width="200"
        prop="trackIntactRate"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{ ((parseFloat(scope.row.trackIntactRate) || 0) * 100).toFixed(2) + '%' }}</span>
        </template>
      </el-table-column>

      <el-table-column
        align="center"
        label="轨迹签收推送率(Porcentagem de envio de rastreio de assinatura)"
        min-width="200"
        prop="trackSignPushRate"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{ ((parseFloat(scope.row.trackSignPushRate) || 0) * 100).toFixed(2) + '%' }}</span>
        </template>
      </el-table-column>

      <el-table-column
        align="center"
        label="轨迹签收推送准时率(Porcentagem de pontualidade do envio de rastreio de assinatura)"
        min-width="250"
        prop="trackSignPushOnTimeRate"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{
            ((parseFloat(scope.row.trackSignPushOnTimeRate) || 0) * 100).toFixed(2) + '%'
          }}</span>
        </template>
      </el-table-column>

      <el-table-column
        align="center"
        label="签收pdd推送率(de impulso de assinatura PDD)"
        min-width="200"
        prop="signPodPushRate"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{ ((parseFloat(scope.row.signPodPushRate) || 0) * 100).toFixed(2) + '%' }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import dayjs from 'dayjs';

export default {
  props: {
    dataQualityForRegionList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      dateArr: []
    };
  },
  created() {
    this.dateArr = [this.getAWeek().startDate + ' 00:00:00', this.getAWeek().endDate + ' 23:59:59'];
  },
  methods: {
    // 获取最近15天时间
    getAWeek() {
      return {
        endDate: dayjs().format('YYYY-MM-DD'),
        startDate: dayjs().subtract(15, 'day').format('YYYY-MM-DD')
      };
    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        const targetRegionName = row.region;
        if (!targetRegionName || targetRegionName === '~') {
          return [1, 1];
        }
        if (rowIndex > 0) {
          const prevRow = this.dataQualityForRegionList[rowIndex - 1];
          if (prevRow?.region === targetRegionName) {
            return [0, 1];
          }
        }
        let rowspan = 1;
        console.log(rowIndex, 'rowIndex', this.dataQualityForRegionList.length);
        for (let i = rowIndex + 1; i < this.dataQualityForRegionList.length; i++) {
          const currRow = this.dataQualityForRegionList[i];
          if (currRow?.region && currRow.region === targetRegionName && currRow.region !== '~') {
            rowspan++;
          } else {
            break;
          }
        }
        return [rowspan, 1];
      }
      return [1, 1];
    }
  }
};
</script>

<style>
.table-active {
  color: #00A551;
  cursor: pointer;
}

.stateType .el-input__inner {
  border: 0;
  padding: 0;
  height: 28px;
  line-height: 28px;
  font-weight: bold;
}
</style>
<style lang="scss" scoped>
.selectLabel ::v-deep .el-input__inner {
  height: 28px !important;
  line-height: 28px !important;
  border: none;
  font-weight: bold !important;
  text-align: left;
  padding-left: 0;
}

.selectLabel ::v-deep .el-input__icon {
  line-height: 28px !important;
}
</style>
